export type LockedDimension = 'width' | 'height';

export const DEFAULT_LOCKED_DIMENSION: LockedDimension = 'width';

/** Default locked width for new text/image items (centimeters). */
export const DEFAULT_LOCKED_WIDTH_CM = 76;

/** Minimum item width adjustable via the size slider (centimeters). */
export const MIN_ITEM_WIDTH_CM = 1;
